import * as React from 'react';

/**
 * Context which holds the route prop for a screen.
 */
export const NavigationRouteContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=NavigationRouteContext.js.map